const STORAGE_KEY = "OutbackUiLanguage"

export const getStoredUiLanguage = () => {
	try {
		return (localStorage.getItem(STORAGE_KEY) || "en").toLowerCase()
	} catch {
		return "en"
	}
}

export const setStoredUiLanguage = (language) => {
	try {
		localStorage.setItem(STORAGE_KEY, language?.toLowerCase() || "en")
	} catch {
		// ignore storage errors
	}
}
